import React from 'react'
import { FeatureFlag } from 'utils/feature-flag'

export default function AccessoryLink({ isAccessoryShopOpen, setIsAccessoryShopOpen, linkText, accessoryCountIndicator }) {
  if (!FeatureFlag.accessoryShop()) {
    return
  }

  const handleClick = (e) => {
    e.preventDefault()
    setIsAccessoryShopOpen(!isAccessoryShopOpen)
  }

  return (
    <div className='config-text__buttons'>
      <a href='#' className='inline-button' onClick={handleClick}>
        {linkText}
        {accessoryCountIndicator !== 0 ? (
          <span className='cart-amount-indicator'>{accessoryCountIndicator}</span>
        ) : null}
      </a>
    </div>
  )
}
